import { render, staticRenderFns } from "./ModalTariffPaymentAdd.vue?vue&type=template&id=5a051294"
import script from "./ModalTariffPaymentAdd.vue?vue&type=script&lang=js"
export * from "./ModalTariffPaymentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a051294')) {
      api.createRecord('5a051294', component.options)
    } else {
      api.reload('5a051294', component.options)
    }
    module.hot.accept("./ModalTariffPaymentAdd.vue?vue&type=template&id=5a051294", function () {
      api.rerender('5a051294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/front/shared/components/Modals/ModalTariffPaymentAdd.vue"
export default component.exports